import { useEffect, useContext, useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";

import { useGetDialogByEventIdQuery } from "src/store/chat/api";
import { ChatSocketIoContext } from "src/shared-features/Wrappers";
import { createDialogfromApi } from "../helpers";

//if current page route is one of set of event space page routes
//then this hook is stated with corresponding dialog value
export const useEventSpaceDialog = () => {
  const { pathname } = useLocation();
  const pathTemplate = {
    path: "catalog/event/:id/space",
    end: false
  };
  const pathMatch = matchPath(pathTemplate, pathname);
  const { data, isLoading, refetch } = useGetDialogByEventIdQuery(
    { eventId: pathMatch?.params.id || "" },
    { skip: !pathMatch?.params.id }
  );

  const chatSocket = useContext(ChatSocketIoContext);

  //if event space group dialog has been returned (recovered)
  useEffect(() => {
    if (!chatSocket?.chatSocket)
      return;

    const newDialogHandler = ({ chat_id }: { chat_id: string; }) => {
      if (chat_id !== pathMatch?.params.id)
        return;

      refetch();
      chatSocket?.chatSocket?.emit("addRoom", { chat_id });
    };

    chatSocket?.chatSocket?.on("newDialog", newDialogHandler);
    return () => {
      chatSocket?.chatSocket?.off("newDialog", newDialogHandler);
    };
  }, [chatSocket?.chatSocket, pathMatch?.params.id]);

  const dialog = useMemo(() => data && createDialogfromApi(data), [data]);

  return { dialog, isLoading };
};
